/* eslint-disable no-console */
export const GTM_ID = process.env.REACT_APP_GTM_ID;

// export const pageview = (url) => {
//   window.dataLayer.push({
//     event: 'pageview',
//     page: url,
//   })
// }

export const pageview = (title, type) => {
  //console.log("title==>",title,"type==>",type)
  window.dataLayer = window.dataLayer || [];
  window?.dataLayer?.push({
    event: 'event - pageView',
    pageTitle: title,
    pageType: type,
  });
};
export const pageEventName = (pageName) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: `event - ${pageName}`,
  });
};

// export const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;

// export const pageview = (title, type) => {
//   //console.log("title==>",title,"type==>",type)
//   // window.dataLayer = window.dataLayer || [];
//   window?.dataLayer?.push({
//     event: 'event - pageView',
//     pageTitle: title,
//     pageType: type,
//   });
// };
// export const pageEventName = (pageName) => {
//   window.dataLayer = window.dataLayer || [];
//   window.dataLayer.push({
//     event: `event - ${pageName}`,
//   });
// };
